enum MATERIAL_ACCESS {
  STUDENT = 'student',
  LECTURER = 'lecturer',
  ALL = 'all',
}

export default MATERIAL_ACCESS;
